<template>
  <div class="content">
    <template v-if="resourceList.length === 0 && !isSearch">
      <Empty :isSearch="isSearch" :imgSrc="require('@/assets/img/bj_zanwu@2x.png')" />
      <a-button class="empty-add" type="primary" @click="resourceAdd">
        {{ $t('privateResource.newResource') }}
      </a-button>
    </template>
    <template v-else>
      <div class="title" v-if="loginType === 1">{{ title || $t('privateResource.title') }}</div>
      <div class="actions">
        <a-row type="flex" align="middle" justify="space-between">
          <a-col :span="16" :xl="11" :xxl="11" :lg="10">
            <div class="search">
              <a-row :gutter="16" align="center" justify="space-between">
                <a-col :span="12">
                  <a-input-search
                    class="l-search"
                    allowClear
                    v-model="searchForm.name"
                    :placeholder="$t('privateResource.search.placeholder')"
                    @change="search"
                  >
                    <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
                    <img
                      class="clear"
                      v-if="searchForm.name"
                      slot="suffix"
                      @click=";(searchForm.name = undefined), getList()"
                      :src="require('@/assets/icons/icon_gb.png')"
                    />
                    <a-button class="search-btn" slot="enterButton">
                      {{ $t('privateResource.search.search') }}
                    </a-button>
                  </a-input-search>
                </a-col>
                <a-col :span="6">
                  <a-select
                    @change="handleChange"
                    :placeholder="$t('privateResource.search.shareStatus')"
                    v-model="searchForm.status"
                    :disabled="common.isGoCommon || share.isGoCommon"
                  >
                    <a-select-option v-for="item in statusList" :value="item.value" :key="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="6">
                  <a-select
                    @change="handleChange"
                    :placeholder="$t('privateResource.search.resourceBelong')"
                    v-model="searchForm.belong"
                    :disabled="common.isGoCommon || share.isGoCommon"
                  >
                    <a-select-option :value="0">
                      {{ $t('privateResource.search.belongOptions.all') }}
                    </a-select-option>
                    <a-select-option :value="1">
                      {{ $t('privateResource.search.belongOptions.self') }}
                    </a-select-option>
                    <a-select-option :value="2">
                      {{ $t('privateResource.search.belongOptions.others') }}
                    </a-select-option>
                  </a-select>
                </a-col>
              </a-row>
            </div>
          </a-col>
          <a-col :span="8" :xl="13" :xxl="13" :lg="14">
            <div class="btns">
              <a-button type="primary" :class="['gray', common.flag ? 'disable' : '']" :disabled="common.flag">
                <div v-if="share.flag">
                  <span @click.stop="handleShareModal" :class="[!getIsCheckedTotal.length ? 'disable' : '']">
                    {{ $t('privateResource.actions.next') }}
                  </span>
                  <span class="font-gray">|</span>
                  <span @click="cancelShare(share)" class="font-gray font-cancel">
                    {{ $t('privateResource.actions.cancel') }}
                  </span>
                </div>
                <div
                  v-else
                  @click="
                    () => {
                      handleShare(share)
                      model = 'share'
                    }
                  "
                >
                  {{ $t('privateResource.actions.shareToOthers') }}
                </div>
              </a-button>
              <a-button type="primary" @click="massUpload" class="gray">
                {{ $t('privateResource.actions.batchUpload') }}
              </a-button>
              <a-button type="primary" @click="resourceAdd">
                {{ $t('privateResource.actions.uploadResource') }}
              </a-button>
            </div>
          </a-col>
        </a-row>
      </div>
      <div class="resource">
        <div class="resource-types">
          <div class="lable">{{ $t('privateResource.resourceType') }}:</div>
          <div class="type">
            <div
              :class="['type-item', item.checked ? 'checked' : '']"
              v-for="(item, inx) in types"
              :key="inx"
              @click="changeType(item)"
            >
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>
      <div class="resource" v-if="resourceList.length > 0">
        <div class="roll-area" ref="rollArea">
          <div class="resource-list">
            <div class="resource-item" v-for="item in resourceList" :key="item.id">
              <Card :info="item" :loginType="loginType" @ok="getList(1);isSearch = false" />
            </div>
          </div>
        </div>
        <Pagination class="list-pagination" :pagination.sync="pagination" @handleTableChange="handlePaginationChange" />
      </div>
      <template v-else>
        <Empty v-if="searchForm.name" :imgSrc="require('@/assets/img/bj_zanwu.png')" :text="$t('noDataEmpty')" :isSearch="true" />
        <Empty v-else :imgSrc="require('@/assets/img/bj_zanwu@2x.png')" :text="$t('noDataEmpty')" />
      </template>
    </template>
    <TipModal
      @ok="handleCommonSubmit"
      :visible="common.visible && isAction"
      @cancel="common.visible = false"
      :desc="
        `<p>${$t('privateResource.dialog.shareConfirm')}</p>
        <p class='placeholder'>${$t('privateResource.dialog.shareHint')}</p>`"
    />
    <a-modal class="l-tip" v-model="visible" :title="null" on-ok="handleOk" :closable="false">
      <template slot="footer">
        <a-button key="submit" type="primary" @click="visible = false">
          {{ $t('privateResource.dialog.iKnow') }}
        </a-button>
      </template>
      <p v-if="model === 'share'">{{ $t('privateResource.dialog.noShareResource') }}</p>
      <p v-else>{{ $t('privateResource.dialog.allShared') }}</p>
    </a-modal>
    <!--批量上传-->
    <a-modal
      v-model="massUploadvisible"
      :title="$t('privateResource.dialog.batchUpload')"
      width="515px"
      :footer="null"
      @ok="massUploadHandleOk"
      @cancel="massUploadHandleOk"
    >
      <MassUpload ref="MassUpload" @ok="getList(1)" @hideVisible="massUploadvisible = false" @changeMassUploadvisible="visible => (massUploadvisible = visible)" />
    </a-modal>
    <!--分享-->
    <ShareModal ref="ShareModal" :resourceList="resourceList" @ok="shareOk" />
  </div>
</template>

<script>
import cookie from 'js-cookie'
import debounce from 'lodash.debounce'
import Card from './components/Card.vue'
import MassUpload from './components/MassUpload.vue'
import ShareModal from './components/ShareModal.vue'
import Pagination from '@/components/pagination/index.vue'
import TipModal from '@/components/tipModal/index.vue'
import Empty from '@/components/Empty/index.vue'
import { mapGetters } from 'vuex'
import { getPersonResList, common, resTypeMap } from '@/api/lesson'

export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  components: {
    Card,
    Empty,
    Pagination,
    TipModal,
    MassUpload,
    ShareModal
  },
  data() {
    return {
      searchForm: {
        name: '',
        status: 0,
        belong: 0,
        type: ''
      },
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      info: {
        cover: '',
        name: '',
        createTime: '',
        tip: '',
        checked: true,
        isCkecked: false
      },
      types: [],
      share: {
        flag: false,
        visible: false,
        isGoCommon: false
      },
      common: {
        flag: false,
        visible: false,
        isGoCommon: false
      },
      resourceList: [],
      isSearch: false,
      statusList: [
        {
          label: this.$t('privateResource.status.all'),
          value: 0
        },
        {
          label: this.$t('privateResource.status.unshared'),
          value: 4
        },
        {
          label: this.$t('privateResource.status.sharing'),
          value: 1
        }
      ],
      isAction: true,
      visible: false,
      isStudent: false,
      model: '',
      massUploadvisible: false
    }
  },
  watch: {
    searchForm: {
      handler: debounce(function(newVal, oldVal) {
        // 这里是防抖后的回调函数
        this.pagination.page = 1
        this.isSearch = true
        this.getList()
      }, 500),
      deep: true
    },
    $route(to, from) {
      if (from.name === 'teacherResourceAdd') this.getList()
    }
  },
  computed: {
    ...mapGetters(['loginType']),
    getIsCheckedTotal() {
      return this.resourceList.filter(item => item.checked)
    },
    reversedNameMap() {
      return {
        text: this.$t('privateResource.resourceTypes.text'),
        image: this.$t('privateResource.resourceTypes.image'),
        audio: this.$t('privateResource.resourceTypes.audio'),
        video: this.$t('privateResource.resourceTypes.video'),
        model: this.$t('privateResource.resourceTypes.model'),
        software: this.$t('privateResource.resourceTypes.software')
      }
    }
  },
  methods: {
    resourceAdd() {
      const model = this.$route.query.model || 'teacher'
      this.$router.push({
        name: model === 'admin' ? 'teacherResourceAdd' : 'resourcePrivateAdd',
        query: {
          model: model
        }
      })
    },
    toggleShare() {
      this.isShare = !this.isShare
    },
    async handleShare(data) {
      this.changeType({ label: '全部', value: '' })
      data.flag = true
      data.isGoCommon = true
      // data.visible = true
      this.isAction = false
      this.searchForm.belong = 1
    },
    cancelShare(data) {
      data.flag = false
      data.isGoCommon = false
      data.visible = false
      // this.model = ''
      this.searchForm.belong = 0
      this.resourceList.forEach(item => {
        item.isCkecked = false
      })
    },
    handleCommonSubmit() {
      const ids = this.resourceList.filter(item => item.checked).map(item => item.id)
      common({ ids }).then(res => {
        if (res.code !== 200) return
        this.common.visible = false
        this.$message.success('共享成功')
        this.getList()
        this.cancelShare(this.common)
      })
    },
    massUpload() {
      this.massUploadvisible = true
      this.$nextTick(() => {
        this.$refs.MassUpload.showModal()
      })
    },
    massUploadHandleOk() {
      this.$refs.MassUpload.handleOk()
    },
    handleCommonModal() {
      if (!this.getIsCheckedTotal.length) return
      this.common.visible = true
    },
    handleShareModal() {
      if (!this.getIsCheckedTotal.length) return
      this.$refs.ShareModal.showModal()
    },
    getList(page) {
      if (page) this.pagination.page = page
      const params = {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize,
        ...this.searchForm
      }
      if (this.share.flag) {
        // params.status = 4
      } else if (this.common.flag) {
        params.status = 5
      }
      const filteredParams = Object.fromEntries(
        Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
      )
      return new Promise((resolve, reject) => {
        getPersonResList(filteredParams).then(res => {
          if (res.code !== 200) return
          if (res.data.list.length && this.model) {
            this.isAction = true
          } else if (!res.data.list.length && !this.model) {
            this.isAction = true
          }
          if (!this.isAction) {
            if (this.model) {
              this.visible = true
            }
            this.cancelShare(this.share)
            this.cancelShare(this.common)
            return
          }
          this.resourceList = res.data.list.map(item => ({
            id: item.id,
            cover: item.cover,
            name: item.name,
            type: item.type,
            typeName: this.reversedNameMap[item.type],
            createTime: item.createdAt,
            shareStatus: item.shareStatus,
            checked: true,
            isCkecked: false,
            order: item.order,
            url: item.files.length ? item.files[0].url : ''
          }))
          // 兼容admin端
          if (this.$route.name === 'teacherResourceList') {
            this.$nextTick(() => {
              this.$refs.rollArea.style.height = 'calc(100vh - 310px)'
            })
          }
          this.pagination.total = res.data.total
          this.resourceStateChange()
          this.setResourceCover()
          resolve()
        })
      })
    },
    handlePaginationChange() {
      this.getList()
    },
    changeType(val) {
      this.types.forEach(item => {
        if (item.value === val.value) {
          item.checked = true
        } else {
          item.checked = false
        }
      })
      this.searchForm.type = val.value
      // this.getList()
    },
    resourceStateChange() {
      if (!this.share.flag && !this.common.flag) return
      this.resourceList.forEach(item => {
        item.isCkecked = true
      })
    },
    setResourceCover() {
      this.resourceList.forEach(item => {
        if (item.cover) return
        switch (item.type) {
          case 'text':
            if (!item.url) return
            const regex = /\.([a-zA-Z0-9]+)$/
            const match = item.url.match(regex)
            const bgMap = {
              ppt: 'ppt',
              pdf: 'pdf',
              doc: 'word',
              docx: 'word',
              xls: 'xlsx',
              xlsx: 'xlsx',
              pptx: 'ppt'
            }
            if (match) {
              item.cover = require(`@/assets/img/bg_${bgMap[match[1]]}_cover.png`)
            } else {
              item.cover = require('@/assets/img/bg_text_cover.png')
            }
            break
          case 'audio':
            item.cover = require('@/assets/img/bg_auido_cover.png')
            break
          case 'model':
            item.cover = require('@/assets/img/bj_mx@2x.png')
            break
          case 'software':
            item.cover = require('@/assets/img/bj_sx@2x.png')
            break
        }
      })
    },
    shareOk() {
      this.cancelShare(this.share)
    },
    getResTypeMap() {
      // resTypeMap().then(res => {
      //   if (res.code !== 200) return
      //   this.types = res.data.list.map(item => ({
      //     label: item.name,
      //     value: item.id,
      //     checked: false
      //   }))
      //   this.types.unshift({
      //     label: '全部',
      //     value: '',
      //     checked: true
      //   })
      // })
      this.types = [
        {
          label: this.$t('personal.resource.all'),
          value: '',
          checked: true
        },
        {
          label: this.$t('personal.resource.resourceType.model'),
          value: 'model',
          checked: false
        },
        {
          label: this.$t('personal.resource.resourceType.software'),
          value: 'software',
          checked: false
        },
        {
          label: this.$t('personal.resource.resourceType.text'),
          value: 'text',
          checked: false
        },
        {
          label: this.$t('personal.resource.resourceType.image'),
          value: 'image',
          checked: false
        },
        {
          label: this.$t('personal.resource.resourceType.video'),
          value: 'video',
          checked: false
        },
        {
          label: this.$t('personal.resource.resourceType.audio'),
          value: 'audio',
          checked: false
        }
      ]
    },
    handleChange() {
      this.isAction = true
    }
  },
  mounted() {
    this.getList()
    this.getResTypeMap()
    this.$nextTick(() => {
      setTimeout(() => {}, 2000)
    })
    const userType = JSON.parse(cookie.get('user_type')).join(',')
    if (userType.includes('student')) {
      this.isStudent = true
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 22px;
  .l-empty{
    padding-top: 50vh;
    margin-top: -204px !important;
  }
  .font-gray {
    color: #b0c0d4;
  }
  .font-cancel {
    padding-left: 5px;
  }
  .disable {
    cursor: not-allowed !important;
  }
  .empty-add {
    margin: 10px auto;
    margin-top: -180px;
    display: block;
  }
  .title {
    line-height: 50px;
    font-size: 16px;
    font-weight: bold;
    color: #000;
  }
  .actions {
    margin-top: 10px;
    margin-bottom: 22px;
    .search {
      /deep/.ant-input,
      /deep/.ant-select,
      /deep/.ant-input-affix-wrapper {
        width: 100%;
        height: 35px;
        color: #000;
        margin-right: 30px;
        border-radius: 20px;
        .ant-input-prefix,
        .ant-input-suffix {
          > img {
            width: 16px;
            cursor: pointer;
          }
        }
        .ant-input-suffix .clear {
          width: 14px;
          height: 14px;
        }
        .ant-input:not(:last-child) {
          padding-right: 80px;
        }
      }
      /deep/.ant-input-group-wrapper {
        // width: 330px;
        height: 35px;
        position: relative;
        .ant-input-prefix {
          // right: auto;
          left: 16px;
          img {
            width: 16px;
          }
        }
        .ant-input-suffix {
          right: 67px;
          .anticon.anticon-close-circle.ant-input-clear-icon {
            display: none;
          }
          .clear {
            width: 14px;
            height: 14px;
            cursor: pointer;
          }
        }
        .ant-input-search {
          width: 100%;
          height: 35px;
          .ant-input {
            height: 35px;
            color: #000;
            padding-left: 46px;
            border-radius: 20px;
            box-shadow: none;
            border: 1px solid #d8dce0;
            &:focus {
              border-color: #ffb829;
              box-shadow: 0 0 0 2px rgba(255, 160, 0, 0.2);
            }
          }
        }
        .ant-input-group-addon {
          position: absolute;
          right: 63px;
          top: 0;
          border-radius: 20px;
          z-index: 2;
          background: none;
          .search-btn {
            border-left: 0;
            height: 35px;
            border-color: rgba(0, 0, 0, 0);
            border-top-right-radius: 20px;
            border-bottom-right-radius: 20px;
            background: none;
            padding-right: 109px;
            display: inline-block !important;
            &::after {
              content: none;
            }
            span {
              display: flex;
              font-size: 14px;
              color: #333333;
              position: relative;
              align-items: center;
              &::before {
                left: -8px;
                content: '';
                width: 1px;
                height: 15px;
                background: #e9e9e9;
                position: absolute;
              }
            }
          }
        }
        // border: 1px solid #D8DCE0;
      }
      /deep/ .ant-select-selection {
        border-radius: 20px;
        height: 35px;
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 35px;
        margin-left: 22px;
      }
    }
    .btns {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-wrap: wrap;
      /deep/.ant-btn {
        margin-left: 10px;
      }
      .gray {
        background: linear-gradient(248deg, #72899d 0%, #9bb3c8 100%);
      }
    }
  }
  .resource {
    .resource-types {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 25px;
      .lable {
        font-size: 14px;
        margin-right: 15px;
        color: #687f9c;
      }
      .type {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .type-item {
          color: #000;
          padding: 0 10px;
          cursor: pointer;
          position: relative;
          .cur {
            width: 100%;
            height: 4px;
            border-radius: 5px;
            background: #ff6d00;
            position: absolute;
            bottom: -8px;
            left: 0;
          }
        }
        .checked {
          font-weight: bold;
          color: #ff6d00;
          display: flex;
          justify-content: center;
          align-content: center;
          // &::after {
          //   bottom: -8px;
          //   content: '';
          //   width: 23px;
          //   height: 4px;
          //   background: #ff6d00;
          //   border-radius: 3px;
          //   position: absolute;
          // }
          // border-bottom: 4px solid #000;
        }
      }
    }
    .roll-area {
      height: calc(100vh - 256px);
      overflow-y: auto;
      margin-right: -12px;
      .resource-list {
        display: flex;
        flex-wrap: wrap;
        padding-right: 10px;
        .resource-item {
          width: calc((100% - 88px) / 5);
          margin-right: 22px;
          margin-top: 22px;
        }
        .resource-item:nth-child(-n + 5) {
          margin-top: 0;
        }
        .resource-item:nth-child(5n) {
          margin-right: 0;
        }
      }
    }
    .roll-area::-webkit-scrollbar-thumb {
      background: #e8e9ea;
    }
    .list-pagination {
      position: relative;
      // // bottom: 50px;
      // width: calc(100% - 44px);
    }
  }
}
.l-tip {
  /deep/.ant-modal {
    top: 30%;
    padding-bottom: 0;
    width: 320px !important;
    .ant-modal-content {
      background: url('~@/assets/img/bj_ts.png');
      background-size: 100% 100%;
      background-position: center;
    }
    .ant-modal-header {
      background: none;
      border-bottom: 0;
      .ant-modal-title {
        font-size: 16px;
        font-weight: 800;
        color: #000000;
        line-height: 22px;
      }
    }
    .ant-modal-body {
      display: flex;
      font-size: 16px;
      font-weight: 800;
      color: #000000;
      line-height: 22px;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      padding: 28px 22px 0;
      p {
        font-size: 16px;
        font-weight: 800;
        color: #000000;
        line-height: 26px;
        margin-bottom: 9px;
        text-align: center;
        &:last-child {
          margin-bottom: 22px;
        }
      }
      .placeholder {
        font-size: 14px;
        font-weight: 400;
        color: #596777;
        line-height: 20px;
        margin-top: 12px;
      }
      .text {
        font-size: 14px;
        font-weight: 400;
        color: #2c3b4d;
      }
      .text-left {
        text-align: left;
        display: flex;
        flex-direction: column;
        .title {
          display: flex;
          align-items: center;
          .icon {
            width: 19px;
            height: 15px;
            margin-right: 7px;
          }
        }
        .text {
          padding-left: 26px;
          display: inline-block;
        }
        &:last-child {
          margin-bottom: 0 !important;
        }
      }
      .noPermission {
        width: 133px;
      }
      .login-out {
        width: 100%;
        display: flex;
        margin-top: -20px;
        position: relative;
        justify-content: center;
        .ant-btn {
          width: 84px;
          height: 30px;
          font-size: 14px;
          font-weight: 500;
          color: #8c8c8c;
          line-height: 20px;
          border-radius: 15px;
          border: 1px solid #dcdcdc;
        }
      }
    }
    .ant-modal-close-x {
      opacity: 0;
    }
    .ant-modal-footer {
      display: flex;
      border-top: 0;
      padding: 0 0 22px;
      justify-content: center;
      .ant-btn,
      .ant-btn:hover {
        border: 0;
        min-width: 94px;
        height: 35px;
        color: #9b1205;
        border-radius: 6px;
        background: #fcf3ec;
        box-shadow: 0px 0px 3px 0px rgba(204, 76, 26, 0.12);
      }
      .ant-btn.ant-btn-primary,
      .ant-btn.ant-btn-primary:hover {
        border: 0;
        width: auto;
        height: 35px;
        color: #fff;
        margin-left: 0px;
        background: linear-gradient(248deg, #ff6d00 0%, #f5a623 100%);
        box-shadow: 0px 0px 3px 0px rgba(204, 76, 26, 0.12);
        border-radius: 6px;
      }
    }
  }
}
@media screen and (max-width: 1500px) {
  .search-btn {
    display: none;
  }
}
</style>
